import { ColumnProps } from "./Grid.types";

export function Column({ children, className, style }: ColumnProps) {
  return (
    <div style={style} className={`col ${className ? className : ""}`}>
      {children}
    </div>
  );
}
